/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { USER_UPDATE_FIELDS } from './users.shared';

export const GET_USERS_FOR_CONTRACTOR = gql`
  query {
    contractorUsers {
      id
      firstName
      lastName
      email
      userType
      userRole
      acceptedTosAt
      displayColour
      createdAt
      deletedAt
    }
  }
`;

export const GET_USER_FOR_CONTRACTOR = gql`
  query ($id: String!) {
    contractorUser(id: $id) {
      id
      firstName
      lastName
      email
      userType
      userRole
      displayColour
      settings
      acceptedTosAt
      createdAt
      deletedAt
      userRelations {
        relationType
        createdAt
      }
    }
  }
`;

export const GET_ACTIVE_USERS_FOR_CONTRACTOR = gql`
  query {
    contractorActiveUsers {
      id
      firstName
      lastName
      displayColour
    }
  }
`;

export const CREATE_USER_FOR_CONTRACTOR = gql`
  mutation ($firstName: String!, $lastName: String!, $email: String!, $userRole: String!, $displayColour: String) {
    contractorCreateUser(input: {
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      userRole: $userRole,
      displayColour: $displayColour,
    }) {
      id
    }
  }
`;

export const DELETE_USER_FOR_CONTRACTOR = gql`
  mutation ($id: String!) {
    contractorDeleteUser(id: $id)
  }
`;

export const UPDATE_CONTRACTOR_USER = gql`
  ${USER_UPDATE_FIELDS}
  mutation ($id: String!, $firstName: String!, $lastName: String!, $email: String!, $userRole: String!, $displayColour: String) {
    updateContractorUser(input: {
      id: $id,
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      userRole: $userRole,
      displayColour: $displayColour,
    }) {
      ...UserUpdateFields
    }
  }
`;

export const UPDATE_CONTRACTOR_USER_SETTINGS = gql`
  mutation UpdateContractorUserSettings($settings: UserSettingsJSON) {
    contractorUpdateUserSettings(input: { settings: $settings }) {
      success
    }
  }
`;

export const RESEND_USER_INVITATION_FOR_CONTRACTOR = gql`
  mutation ($id: String!) {
    contractorResendUserInvitation(id: $id)
  }
`;
